// src/helper/gannHelper.js
// Gann Square of 9 levels: R/S = (sqrt(base) ± n × degree/180)²

const roundToTick = (price, tick = 0.05) =>
  Number((Math.round(price / tick) * tick).toFixed(2));

export const calculateGannLevels = (basePrice, degree = 45) => {
  const base = Number(basePrice);
  if (!Number.isFinite(base) || base <= 0) return null;

  const root = Math.sqrt(base);
  const step = degree / 180; // 45° → 0.25

  return {
    base: roundToTick(base),
    degree,
    r1: roundToTick((root + step) ** 2),
    r2: roundToTick((root + step * 2) ** 2),
    s1: roundToTick((root - step) ** 2),
    s2: roundToTick((root - step * 2) ** 2),
  };
};

// Rows for the detail-page table, high → low, with live distance + status
export const GANN_ROWS = [
  { key: "r2", label: "R2", type: "Resistance" },
  { key: "r1", label: "R1", type: "Resistance" },
  { key: "base", label: "Base", type: "Prev close" },
  { key: "s1", label: "S1", type: "Support" },
  { key: "s2", label: "S2", type: "Support" },
];

export const getGannStatus = (key, levelPrice, ltp) => {
  if (!Number.isFinite(ltp) || ltp <= 0) return { text: "—", cls: "" };
  if (key.startsWith("r"))
    return ltp > levelPrice
      ? { text: "Broken ↑", cls: "stockpro-green" }
      : { text: "Resistance ahead", cls: "" };
  if (key.startsWith("s"))
    return ltp < levelPrice
      ? { text: "Broken ↓", cls: "stockpro-red" }
      : { text: "Support below", cls: "" };
  return ltp >= levelPrice
    ? { text: "Trading above", cls: "stockpro-green" }
    : { text: "Trading below", cls: "stockpro-red" };
};

export const getNearestGannKey = (levels, ltp) => {
  if (!levels || !Number.isFinite(ltp) || ltp <= 0) return null;
  let bestKey = null;
  let best = Infinity;
  GANN_ROWS.forEach(({ key }) => {
    const d = Math.abs(Number(levels[key]) - ltp);
    if (d < best) {
      best = d;
      bestKey = key;
    }
  });
  return bestKey;
};
